import { BaseContainerModel } from "../base-container.model";
import { bl_fi_generic_doc_line_close_queue_RowClass } from "../../dbschema";

export class GenericDocLineCloseQueueContainerModel extends BaseContainerModel {
  bl_fi_generic_doc_line_close_queue: bl_fi_generic_doc_line_close_queue_RowClass =
    new bl_fi_generic_doc_line_close_queue_RowClass();
}
